import { select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { ctaLabelSelectorProps } from '@grandvisionhq/configurator';
import { isBookAppointmentEntrySelection } from '../../../types.js';
import { getPrescriptionType, getRoutes, getRxEntryTypes } from '../../selectors.js';
import { PrescriptionEntrySelectionStepContainer } from '../../../../Configurator/steps/PrescriptionEntrySelectionStep/PrescriptionEntrySelectionStepContainer.js';

const prescriptionEntrySelectionStepBase = {
    *onNext () {
        const prescriptionType = yield select(getPrescriptionType);
        // This should never happen, but we should handle it anyway. We'll block proceeding to the next step.
        if (!prescriptionType) {
            return new Error(`Prescription type is not defined`);
        }
        if (isBookAppointmentEntrySelection(prescriptionType)) {
            const routes = yield select(getRoutes);
            const bookAppointmentRoute = (routes === null || routes === void 0 ? void 0 : routes['book-appointment']) || (routes === null || routes === void 0 ? void 0 : routes['appointment-book']);
            if (!routes || !bookAppointmentRoute) {
                return new Error('Cannot redirect to Book Appointment. No book-appointment URL defined in the RxConfigurator');
            }
            window.location.assign(bookAppointmentRoute);
            // We are returning an error in order to prevent going to the next step.
            // Since this is the expected behavior, it's not a true "error" situation.
            return new Error('Canceling RxConfigurator flow. User chose to redirect to Book Appointment');
        }
    },
    view: PrescriptionEntrySelectionStepContainer,
    ctaLabel: createSelector(ctaLabelSelectorProps, getPrescriptionType, getRxEntryTypes, ({ defaultCtaLabel  }, prescriptionType, rxEntryTypes)=>{
        var ref;
        const defaultKey = {
            key: defaultCtaLabel
        };
        if (!prescriptionType || !rxEntryTypes || (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes.length) === 0) {
            return defaultKey;
        }
        const label = (ref = rxEntryTypes.find((entry)=>prescriptionType === entry.key
        )) === null || ref === void 0 ? void 0 : ref.ctaLabel;
        /**
       * overrideLastCta
       * In case of AB testing for configurator step sequence when prescription entry selection
       * is the last step, the configurator will override the CTA button to add to cart.
       * by setting overrideLastCta to true, we will prevent the configurator to do so.
       */ return label ? {
            value: label,
            overrideLastCta: isBookAppointmentEntrySelection(prescriptionType)
        } : defaultKey;
    })
};

export { prescriptionEntrySelectionStepBase };
//# sourceMappingURL=prescription-entry-selection.js.map
